import React, { useEffect, CSSProperties } from 'react';
import { Tabs, Tab } from 'baseui/tabs-motion';
import { mergeOverrides, useStyletron } from 'baseui';
import { IDummyProps } from './types';
import { withPermissionsProps } from '../../Utilities/hoc/withPermissions';
// import { Tab } from '../Tab';
import { iconContainerButton, IconContainerF, tabWrapperStyles } from './styles';
import { MIcon } from '../Icon';
import { customTabOverrides, overrides as customOverrides } from './overrides';
import * as meta from '../../meta-data.json';
import { StyleObject } from 'src/Themes';
type EpoType = IDummyProps & withPermissionsProps;

export const View = React.forwardRef((props: EpoType, ref: any) => {
	const colorIconDefault = 'var(--epods--color-text-tab)';
	const colorIconActive = 'var(--epods--color-text-primary-action)';
	const [activeKey, setActiveKey] = React.useState<React.Key>(0);
	const [colorIconLeft, setColorIconLeft] = React.useState<string>(colorIconDefault);
	const [colorIconRight, setColorIconRight] = React.useState<string>(colorIconDefault);
	const {
		orientation = 'horizontal',
		fill = 'default',
		initTab = 0,
		reverse,
		activateOnFocus = false,
		overrides,
		size = 'default',
		arrows,
		onChange,
		onTabChange,
		...rest
	} = props;
	const IconRight = IconContainerF({ reverse: reverse }, 'right');
	const IconLeft = IconContainerF({ reverse: reverse }, 'left');
	const [css] = useStyletron();

	// TODO: move to index.tsx, and review the types if they are in the correct interface
	useEffect(() => {
		setActiveKey(initTab);
	}, [initTab]);

	const getMax = () => {
		let max = 0;
		if (props.items) {
			max = props.items.length - 1;
		} else {
			for (const child in props.children as any) {
				max++;
			}
		}
		return max;
	};

	const renderAsItems = () => {
		return (
			props.items &&
			props.items.map((item: any, index: number) => {
				return (
					<Tab
						key={index}
						title={item.title}
						disabled={item.disabled}
						overrides={customTabOverrides(item, size, props.headerColor)}
						artwork={item.icon ? item.icon : null}
					>
						{item.content}
					</Tab>
				);
			})
		);
	};

	return (
		<div
			{...{
				'data-epo': `epo-tabs-${meta.version}`,
				part: `epo-tabs-${meta.version}`,
			}}
			style={
				{
					'--epods--tab-font-size': 'var(--epods--tabs-' + size + '-font-size)',
				} as any
			}
			className={`${css(tabWrapperStyles(props))} ${props.className}`}
			ref={ref}
		>
			{orientation === 'vertical'
				? null
				: props.arrows && (
						<IconLeft>
							<button
								aria-label={'Scroll left'}
								tabIndex={0}
								onMouseEnter={() => setColorIconLeft(colorIconActive)}
								onMouseLeave={() => setColorIconLeft(colorIconDefault)}
								className={css(iconContainerButton as StyleObject)}
								onClick={() => {
									setActiveKey(-activeKey === 0 ? 0 : +activeKey - 1);
								}}
							>
								<MIcon size="var(--epods--icon-medium)" color={colorIconLeft} icon="navigate_before" />
							</button>
						</IconLeft>
				  )}
			<Tabs
				activeKey={activeKey}
				onChange={({ activeKey }: { activeKey: React.Key }) => {
					if (onTabChange) {
						onTabChange({ activeKey });
					} else {
						setActiveKey(activeKey);
					}
				}}
				orientation={orientation}
				fill={fill}
				activateOnFocus={activateOnFocus}
				{...rest}
				overrides={
					overrides
						? mergeOverrides(customOverrides(props, orientation), overrides as any)
						: customOverrides(props, orientation)
				}
			>
				{props.items ? renderAsItems() : props.children}
			</Tabs>
			{orientation === 'vertical'
				? null
				: props.arrows && (
						<IconRight>
							{/* TODO : review - tests failing:  <IconRight reverse={reverse?.toString()}>  */}
							<button
								aria-label={'Scroll right'}
								tabIndex={0}
								onMouseEnter={() => setColorIconRight(colorIconActive)}
								onMouseLeave={() => setColorIconRight(colorIconDefault)}
								style={iconContainerButton as CSSProperties}
								onClick={() => {
									setActiveKey(+activeKey === getMax() ? getMax() : +activeKey + 1);
								}}
							>
								<MIcon size={'var(--epods--icon-medium)'} color={colorIconRight} icon="navigate_next" />
							</button>
						</IconRight>
				  )}
		</div>
	);
});
